import { render } from "./CoinModal.vue?vue&type=template&id=f950bfe0&scoped=true"
import script from "./CoinModal.vue?vue&type=script&lang=js"
export * from "./CoinModal.vue?vue&type=script&lang=js"

import "./CoinModal.vue?vue&type=style&index=0&id=f950bfe0&scoped=true&lang=css"

import exportComponent from "/var/www/mobitel/quizgiri/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f950bfe0"]])

export default __exports__